import { motion } from "framer-motion";
import { Flame, Camera, Clock } from "lucide-react";

export const SpotCard = ({ spot, index = 0, onClick }) => {
  return (
    <motion.button
      type="button"
      onClick={onClick}
      data-testid={`spot-card-${spot.id}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.05 * index, ease: [0.2, 0.7, 0.2, 1] }}
      className="text-left group relative aspect-[4/5] rounded-3xl overflow-hidden ring-1 ring-white/10 hover-lift"
    >
      <img src={spot.image} alt={spot.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-[1.05]" />
      <div className="absolute inset-0 scrim-bottom" />
      <div className="absolute top-3 right-3 glass rounded-full px-2 py-1 flex items-center gap-1">
        <Flame className="h-3 w-3 text-[#FE0979]" />
        <span className="font-display font-bold text-[11px]">{spot.viral_score}</span>
      </div>
      <div className="absolute top-3 left-3 glass rounded-full p-1.5">
        <Camera className="h-3 w-3 text-[#00F2FE]" />
      </div>
      <div className="absolute inset-x-0 bottom-0 p-4">
        <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-300 mb-1.5 flex items-center gap-1.5">
          <Clock className="h-3 w-3" /> {spot.best_time?.split(",")[0] || "Best time"}
        </div>
        <h4 className="font-display font-bold text-white text-lg leading-tight text-shadow-soft">{spot.name}</h4>
        <p className="text-zinc-300 text-xs mt-1 truncate">{spot.city}{spot.country ? `, ${spot.country}` : ""}</p>
        <div className="mt-2 flex flex-wrap gap-1">
          {(spot.vibe_tags || []).slice(0, 2).map((t) => (
            <span key={t} className="text-[9px] font-bold uppercase tracking-[0.16em] text-white/90 bg-white/10 rounded-full px-2 py-0.5 border border-white/15">{t}</span>
          ))}
        </div>
      </div>
    </motion.button>
  );
};
